import Gauge from '@/components/Gauge';
import { toFactor } from '@/utilities/formatting';

export interface Props {
  companyName: string;
  companyPB: number;
  industryName: string;
  industryPB: number;
  marketName: string;
  marketPB: number;
}

const keys = ['company', 'industry', 'market'];

const PBRatioGauge = ({
  companyPB,
  industryPB,
  marketPB,
  companyName,
  industryName,
  marketName,
}: Props) => {
  const entities = {
    [keys[0]]: companyPB,
    [keys[1]]: industryPB,
    [keys[2]]: marketPB,
  };
  const entityTitles = {
    [keys[0]]: companyName,
    [keys[1]]: industryName,
    [keys[2]]: marketName,
  };
  return (
    <Gauge
      title="PB Ratio"
      keys={keys}
      entityTitles={entityTitles}
      entities={entities}
      formatter={(value: number | null) =>
        value !== null ? toFactor(value, 1) : 'n/a'
      }
      numTicks={5}
      from={0}
      to={20}
      flip={true}
    />
  );
};

export default PBRatioGauge;
